import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttpResponse } from '@angular/common/http';
import { of } from 'rxjs';

@Injectable()
export class UnprocessableErrorInterceptor implements HttpInterceptor {

	intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
		return next
			.handle(request)
			.pipe(
				catchError((error: HttpErrorResponse) => {
					// Only handle 422 errors, let other errors propagate
					if (error.status === 422) {
						return of(new HttpResponse({
							status: 422,
							body: error.error
						}));
					}
					// For other errors, propagate them to other interceptors
					return throwError(() => error);
				})
			);
	}

}
